var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "selected-filters clearfix" },
    [
      _vm._l(_vm.tagList, function (tag) {
        return _c(
          "span",
          {
            class:
              "text-appearance selected-filter filter-" +
              tag.id +
              " " +
              _vm.marginClasses,
            style: _vm.marginInlineStyles,
            on: {
              click: function ($event) {
                return _vm.removeTag(tag)
              },
            },
          },
          [
            _c("i", {
              staticClass: "fa fa-times",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(tag.name) } }),
          ]
        )
      }),
      _vm._v(" "),
      _vm.tagList.length >= 2
        ? _c(
            "span",
            {
              class:
                "bg-appearance selected-filter reset-all" +
                " " +
                _vm.marginClasses,
              style: _vm.marginInlineStyles,
              on: {
                click: function ($event) {
                  return _vm.resetAllTags()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$translate("Ceres::Template.itemFilterReset")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }